import React from 'react';
import { Button, Paragraph } from '@welbe/web-design-system';
import { ReactComponent as Megaphone } from 'App/assets/img/campaigns_gray.svg';
import { Header, ContainerEmpty, WrapperEmpty } from './Campaigns.styles';

interface CompaignsEmptyProps {
	onCreateNewCampaign: () => void;
}

export const CampaignsEmpty = ({
	onCreateNewCampaign,
}: CompaignsEmptyProps): JSX.Element => {
	return (
		<WrapperEmpty>
			<Header>
				<Paragraph color="#5082C2" fontSize="20px" fontWeight="700">
					NORMA OFICIAL MEXICANA NOM-035-STPS-2018
				</Paragraph>
				<Paragraph textAlign="center" fontSize="18px" fontWeight="500">
					Factores de riesgo psicosocial en el trabajo-identificación, análisis
					y prevención.
				</Paragraph>
			</Header>
			<ContainerEmpty>
				<Megaphone className="megaphone-icon" />
				<Paragraph margin="32px 0">Aún no tienes campañas realizadas</Paragraph>
				<Button width="280px" onClick={onCreateNewCampaign}>
					Crear campaña
				</Button>
			</ContainerEmpty>
		</WrapperEmpty>
	);
};
